import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4xmpwu5f4: FaireProductEntity = {
  token: "p_t4xmpwu5f4",
  type: "product",
  name: "Parachute Pants (2S-2M-2L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/f7d147f23eeaea264b16b642c2460c9675e0a0da90fd34ca1447f604719797ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15abab56d8f489efcd82038af8ed4d6a0dd1bcab30bdc309dbc08770bac49c47.jpeg",
    "https://cdn.faire.com/fastly/87ada725b66865cab35fdd54066105fd832555e858a94d7cdbb822f889992777.jpeg",
    "https://cdn.faire.com/fastly/dbece9eff0960362d2805e6c36411968554ed13cde8ec2951df452a364bee494.jpeg",
    "https://cdn.faire.com/fastly/a49bea538b0c4a8fa02925d17f78c87f1259873dd9318bbd23b59e59370830e7.jpeg",
  ],
  priceDollars: 312,
  description:
    'Why We Made This?\n\nBillowy pants made to move with you throughout the day. Crafted from a light yet durable and elevated cotton they\'re the kind of pair you can wear anywhere, from casual moments to polished looks. Designed with an elastic waist and side pockets, their unique leg shape sets them apart. A third side panel adds extra volume, creating a sculptural silhouette that’s relaxed, airy, and full of movement.\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n• 100% Cotton\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n• Machine wash cold with like colors\n• Do not spot clean\n• Hang dry for best results or tumble dry on low heat\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\nMeasurements are approximate and may deviate by up to 1 inch due to variations depending on the colors and batches in the garment washing process.\n\n• Small: Waist 12"(relaxed/flat), Waist 18"(extended/flat), Hip 25", Inseam 27", Leg opening 11"\n• Medium: Waist 13"(relaxed/flat), Waist 19"(extended/flat), Hip 26", Inseam 27 1/4", Leg opening 11 1/2"\n• Large: Waist 14"(relaxed/flat), Waist 20"(extended/flat), Hip 27", Inseam 27 1/2", Leg opening 12"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size Small\n\nMade in China\n\nMSRP: $110 USD',
  tags: [],
  msrpDollars: 624,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:08.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
